<template>
  <div>
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["1218"]') }}</span>
      <span slot="secondTit">{{ $t('message["1218"]') }}</span>
    </crumb-tit>
    <div
      v-if="datasReady"
      class="notice-setting-box"
    >
      <a-tabs
        v-model="activeName"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          key="system"
          :tab="systemTit"
        >
          <main-list />
        </a-tab-pane>
        <template v-if="!$isDingDing">
          <a-tab-pane
            key="wechat"
            :tab="qwTitTxt"
          >
            <main-list />
          </a-tab-pane>
          <a-tab-pane
            key="wexin"
            :tab="wxTit"
          >
            <main-list />
          </a-tab-pane>
        </template>
        <a-tab-pane
          v-if="isDingtalk"
          key="dingtalk"
          :tab="dingdingTxt"
        >
          <main-list />
        </a-tab-pane>
        <template v-if="!$isDingDing">
          <a-tab-pane
            key="sms"
            :tab="smsTxt"
          >
            <main-list />
          </a-tab-pane>
          <a-tab-pane
            key="email"
            :tab="emailTit"
          >
            <main-list />
          </a-tab-pane>
        </template>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
// import BreadCrumb from '@/common/components/BreadCrumb'
// import SecondMenu from './notice/components/SecondMenu'
import CrumbTit from '@/components/pc/config/CrumbTit'
import MainList from './notice/MainList'
export default {
  name: 'NoticeList',
  components: {
    // BreadCrumb,
    // SecondMenu,
    MainList,
    CrumbTit
  },
  data () {
    return {
      activeName: 'system'
    }
  },
  computed: {
    ...mapGetters('config/notice', ['currentData']),
    ...mapState('config/notice', ['datas', 'datasReady']),
    baseinfo () {
      return this.$store.state.baseinfo
    },
    isDingtalk () {
      return 'dingtalk' in this.datas
    },
    dingdingTxt () {
      return this.$t('message["238"]')
    },
    smsTxt () {
      return this.$t('message["251"]')
    },
    qwTitTxt () {
      return this.$t('message["720"]')
    },
    wxTit () {
      return this.$t('message["1254"]')
    },
    systemTit () {
      return this.$t('message["1291"]')
    },
    emailTit () {
      return this.$t('message["1500"]')
    }
  },
  async mounted () {
    const chain = await this.fetchDatas()
    chain.onSuccess(() => {
      document.title = this.$t('message["1218"]') + ' - ' + this.baseinfo.projectname + '-' + this.baseinfo.comname
    })
      .fetch()
    const chain2 = await this.fetchVarDatas()
    chain2.fetch()
    const chain3 = await this.fetchsmsEmailDatas()
    chain3.fetch()
    this.setTabName('system')
  },
  methods: {
    ...mapMutations('config/notice', ['setTabName']),
    ...mapActions('config/notice', ['fetchDatas', 'fetchsmsEmailDatas', 'fetchVarDatas']),
    handleClick (key) {
      this.setTabName(key)
    }
  }
}
</script>
<style lang="scss" scoped>
  .notice-setting-box::v-deep {
    border-top: 1px solid #ebebeb;
    font-size: 18px;
    margin-top: 16px;
    .ant-tabs-bar {
      border-bottom: none 0;
    }
    .ant-tabs-nav .ant-tabs-tab {
      font-size: 18px;
      font-weight: bold;
    }
  }
</style>
